module.exports = __webpack_public_path__ + "static/ceo-bf1875d50122025b8dbb68eaf50c67c3.png";